import { clientEnvSchema, type TClientEnv } from '../shared';

const parseClientEnv = (): TClientEnv => {
  return clientEnvSchema.parse({
    BUN_PUBLIC_POCKETBASE_URL: process.env.BUN_PUBLIC_POCKETBASE_URL
  });
};

export const clientEnv = parseClientEnv();
